import { useSignInMutation } from "Auth/Api/Mutations/useSignInMutation";
import { FormInput } from "Forms/Components/FormInput";
import useHandleServerError from "Forms/Hooks/useHandleServerError";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { TestIds } from "Shared/testIds";
import { zodResolver } from "@hookform/resolvers/zod";
import { FormProvider, useForm } from "react-hook-form";
import { z } from "zod";
import { Button } from "@/components/ui/button";

const SignInSchema = z.object({
	login: z.string(),
	password: z.string().min(3),
});

type SignInFormModel = z.infer<typeof SignInSchema>;

const PageResources = Resources.SignIn;

export const SignInForm = () => {
	const form = useForm<SignInFormModel>({
		resolver: zodResolver(SignInSchema),
		defaultValues: { login: "", password: "" },
	});
	const { handleSubmit } = form;
	const { t } = useResource();

	const { mutate, error } = useSignInMutation();

	const submit = (data: SignInFormModel) => {
		mutate({ body: data });
	};

	useHandleServerError({
		form,
		error,
		formKey: "login",
		resource: PageResources.Error,
	});

	return (
		<div className="w-full max-w-sm">
			<h1 className="mb-6 text-2xl font-bold">{t(PageResources.Title)}</h1>
			<FormProvider {...form}>
				<form onSubmit={handleSubmit(submit)} className="space-y-4">
					<FormInput
						name="login"
						autoComplete="login"
						label={t(PageResources.Login.Label)}
					/>
					<FormInput
						name="password"
						type="password"
						autoComplete="current-password"
						label={t(PageResources.Password.Label)}
					/>
					<Button
						type="submit"
						className="w-full"
						data-testid={TestIds.signInButton}
					>
						{t(PageResources.Button)}
					</Button>
				</form>
			</FormProvider>
		</div>
	);
};
